module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mx-0 pa-0",
    attrs: {
      "id": "dashboard",
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.stats.monthlyStats), function(stat, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "md3": "",
        "sm6": "",
        "xs12": ""
      }
    }, [_c('v-card', {
      class: stat.bgColor,
      attrs: {
        "dark": ""
      }
    }, [_c('v-container', {
      attrs: {
        "fluid": "",
        "grid-list-sm": "",
        "dark": ""
      }
    }, [_c('v-layout', {
      staticClass: "mt-0 mb-0 mx-1",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "sm3": "",
        "hidden-xs-only": ""
      }
    }, [_c('v-icon', {
      staticClass: "mx-0",
      attrs: {
        "x-large": "",
        "dark": ""
      }
    }, [_vm._v(_vm._s(stat.icon))])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sm9": "",
        "xs12": ""
      }
    }, [_c('v-layout', {
      staticClass: "mt-0 mb-0 pa-0",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "d-flex": "",
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "silver--text subheading"
    }, [_vm._v(_vm._s(stat.title))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "d-flex": "",
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "silver--text display-1"
    }, [_vm._v(_vm._s(stat.data))])])], 1)], 1)], 1)], 1)], 1)], 1)
  })), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "light": ""
    }
  }, [_c('doughnutbanks', {
    key: _vm.banksCompKey,
    style: (_vm.dark ? 'background-color: black;' : ''),
    attrs: {
      "banks": _vm.banks
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "light": ""
    }
  }, [_c('doughnutworkers', {
    key: _vm.workersCompKey,
    style: (_vm.dark ? 'background-color: black;' : ''),
    attrs: {
      "workers": _vm.workers
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "light": ""
    }
  }, [_c('line-chart', {
    style: (_vm.dark ? 'background-color: black;' : ''),
    attrs: {
      "query": _vm.query
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/vue-loader/lib/template-compiler?{"id":"data-v-b7ae69ec","hasScoped":false}!/Users/gtirby/develop/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard.vue
// module id = 421
// module chunks = 0